export const getSubscriptionData = subscriptionSource => {
  const subscription = subscriptionSource && JSON.parse(subscriptionSource);
  return typeof subscription?.data?.has_subscriptions === 'boolean'
    ? { sps: subscription.data.has_subscriptions }
    : {};
};

export const mergeParams = (baseParams, subscriptionData) => ({
  ...baseParams,
  ...subscriptionData,
});
